import { IconAlertTriangle } from '@tabler/icons-react'
import { MantineSpacing, Badge, StyleProp } from '@mantine/core'

type IconPillProps = {
  text: string
  ml?: StyleProp<MantineSpacing>
  hideIcon?: boolean
}

export function PillAlert({ text, ml, hideIcon }: IconPillProps) {
  const iconTriangle = hideIcon ? null : <IconAlertTriangle size={12} stroke={2} />
  return (
    <Badge
      ml={ml}
      leftSection={iconTriangle}
      c='black'
      color='red.2'
      fw={600}
      aria-label={`Alert regarding ${text}`}
    >
      {text}
    </Badge>
  )
}
